import io from 'socket.io-client';

// const socket = io('http://localhost:5000');
const socket = io('https://chat.cstmpanel.com');
export default socket;